import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonModule } from '@angular/material/button';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletMarkerClusterModule } from '@asymmetrik/ngx-leaflet-markercluster';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HomeComponent } from './home.component';
import { HomeDesktopComponent } from './home-desktop/home-desktop.component';
import { HomeMobileComponent } from './home-mobile/home-mobile.component';
import { HomeRoutingModule } from './home-routing.module';
import { PopularPropertiesComponent } from './home-desktop/popular-properties/popular-properties.component';
import { MobilePopularCitiesComponent } from './home-mobile/mobile-popular-cities/mobile-popular-cities.component';
import { MobilePopularPropertiesComponent } from './home-mobile/mobile-popular-properties/mobile-popular-properties.component';
import { ChooseUsComponent } from './home-desktop/choose-us/choose-us.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SearchModule } from './home-desktop/search/search.module';




@NgModule({
    declarations: [
        HomeComponent,
        HomeDesktopComponent,
        HomeMobileComponent,
        PopularPropertiesComponent,
        MobilePopularCitiesComponent,
        MobilePopularPropertiesComponent,
        ChooseUsComponent
    ],
    imports: [
        CommonModule,
        SearchModule,
        HomeRoutingModule,
        MatTabsModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        LeafletModule,
        LeafletMarkerClusterModule,
        NgSelectModule,
        NgbPaginationModule,
        NgxSliderModule,
        TranslateModule,
        MatTooltipModule,
        LazyLoadImageModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeModule { }
